<template>
  <section class="SeasonHero">
    <header class="SeasonHero__header">
      <CrewListLabel
        class="SeasonHero__crew"
        tag="h4"
        :crews="season.crew ? [season.crew] : []"
      />
      <RouterLink
        class="SeasonHero__titleContainer"
        :aria-label="formattedSeasonName ? `View season: ${formattedSeasonName}` : 'View season'"
        :to="{
          name: RouteName.season,
          params: {
            seasonId: season.id,
          },
        }"
      >
        <h3 class="SeasonHero__title">
          {{ formattedSeasonName ?? "New season" }}
        </h3>
        <h4
          v-if="formattedDateRange"
          class="SeasonHero__dateRange"
        >
          {{ formattedDateRange }}
        </h4>
      </RouterLink>
      <RunLocation
        class="SeasonHero__court"
        tag="h4"
        :court="season.court"
      />
    </header>
  </section>
</template>

<script lang="ts" setup>
import CrewListLabel from "@/components/CrewListLabel.vue";
import RunLocation from "@/components/RunLocation.vue";
import useSeasonSchedule from "@/composables/useSeasonSchedule";
import { RouteName } from "@/lib/router/routes";
import { SeasonWithMaybeCourt, SeasonWithMaybeCrew, SeasonWithRuns } from "@shared/lib/database/query.types";
import { toRefs } from "vue";

const props = defineProps<{
  season: SeasonWithMaybeCrew & SeasonWithMaybeCourt & SeasonWithRuns,
}>();

const {
  season,
} = toRefs(props);

const {
  formattedSeasonName,
  formattedDateRange,
} = useSeasonSchedule(season);
</script>

<style lang="scss" scoped>
.SeasonHero__header {
  display: grid;
  gap: 12px;
  padding: 22px 16px 24px;

  background-color: var(--themeColorPrimary);
  color: var(--themeColorPrimaryForeground);

  font-weight: var(--fontWeightMedium);
  font-stretch: var(--fontWidthExtended);
}

.SeasonHero__crew {
  color: var(--themeLightTransparent700);
}

.SeasonHero__title {
  overflow: hidden;

  font-size: var(--titleSize, 32px);
  text-overflow: ellipsis;
  white-space: nowrap;
}

.SeasonHero__titleContainer {
  display: grid;
  gap: 10px;
}

.SeasonHero__dateRange {
  font-size: var(--dateRangeSize, 24px);
}

.SeasonHero__court {
  --iconSize: var(--courtIconSize, 16px);
  color: var(--themeLightTransparent700);
  font-size: var(--courtFontSize, 18px);
}
</style>
